import { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setModal, resetModal } from 'apps/web_forms/slices/appSlice';
import { ModalTypes } from 'apps/web_forms/utils/constants';

export function useExitPageModal(shouldBlock = false) {
  const dispatch = useDispatch();
  const unblockRef = useRef(null);
  const history = useHistory();

  useEffect(() => {
    if (shouldBlock) {
      unblockRef.current = history.block((tx) => {
        // Create a custom retry function that unblocks and navigates
        const retry = () => {
          if (unblockRef.current) {
            unblockRef.current(); // Unblock navigation
          }
          // Navigate to the pending location
          history.push(tx.pathname);
        };

        const setExitPageModalOpen = (isOpen) => {
          if (!isOpen) {
            dispatch(resetModal());
          }
        };

        // Pass the custom retry function along with tx
        dispatch(
          setModal({
            type: ModalTypes.EXIT_PAGE_MODAL,
            extraProps: {
              pendingNavigation: { ...tx, retry },
              setExitPageModalOpen,
            },
          })
        );
        return false;
      });
    } else {
      if (unblockRef.current) {
        unblockRef.current();
        unblockRef.current = null;
      }
    }

    return () => {
      if (unblockRef.current) {
        unblockRef.current();
      }
    };
  }, [shouldBlock, history, dispatch]);

  return { unblockRef };
}
